import $ from 'jquery';
import Cookies from 'js-cookie';
import Breakpoints from 'breakpoints-js';
import utils from './lsag.utils';

const mainNavigation = {

    mainNav: $('#js-main-nav-new'),
    headerGender: $('#js-header-gender'),
    headerGenderMobile: $('#js-header-gender-mobile'),
    copyGender() {
        this.headerGender.html(this.headerGenderMobile.html());
    },
    readGender() {
        let activeGender = Cookies.get('genderSelection');

        if (activeGender === undefined) {
            activeGender = this.headerGender.find('ul li:first').attr('id');
            this.saveGender(activeGender);
        }

        this.setGender(activeGender);
    },
    saveGender(activeGender) {
        Cookies.set('genderSelection', activeGender, {expires: 365});
    },
    setGender(activeGender) {
        this.headerGender.find('ul li').removeClass('active');
        this.headerGender.find('#' + activeGender).addClass('active');
        this.headerGenderMobile.find('ul li').removeClass('active');
        this.headerGenderMobile.find('#' + activeGender).addClass('active');

        this.mainNav.find('.c-main-nav__gender').removeClass('active');
        this.mainNav.find('.c-main-nav__gender.' + activeGender).addClass('active');
    },
    bindGenderSelection() {
        this.headerGender.on('click', '.header-gender-selection li a', (evt) => {
            this.bindGenderSelectionFunction(evt, false);
        });
        this.headerGenderMobile.on('click', '.header-gender-selection li a', (evt) => {
            this.bindGenderSelectionFunction(evt, true);
        });
    },
    bindGenderSelectionFunction(evt, isMobile) {
        evt.preventDefault();
        let self = $(evt.currentTarget);
        let activeGenderNew = self.parent().attr('id');
        this.saveGender(activeGenderNew);
        this.setGender(activeGenderNew);
        sessionStorage.setItem('genderPreSelection', activeGenderNew);
        if (!isMobile) {
            $(location).attr('href', self.attr('href'));
        }

    },
    addComponentsForMobile() {
        // add gender link to mobile
        this.headerGenderMobile.find('li').each((index, element) => {
            let genderId = $(element).attr('id');
            let href = $(element).find('a').attr('href');
            let text = this.headerGenderMobile.attr('data-menutext');
            this.mainNav.find('.c-main-nav__gender.' + genderId).prepend(`
            <li class="c-main-nav__item d-block d-md-none">
                <div class="yCmsComponent c-main-nav__item-title js-main-nav__item-title">
                    <a href="${href}">
                        <span class="c-main-nav__item-text">${text}</span>
                    </a>
                    <i class="c-main-nav__item-icon">
                        <svg class="icon">
                            <use xlink:href="#icon-arrow-right"></use>
                        </svg>
                    </i>
                </div>
            </li>`);
        });

        // add an icon and title on mobile to mark an existing submenu
        this.mainNav.find('.c-sub-nav').each((index, element) => {
            let href = $(element).prev('.js-main-nav__item-title').find('a').attr('href');
            $(element).prev('.js-main-nav__item-title').append(`
                <i class="c-main-nav__item-icon">
                    <svg class="icon">
                        <use xlink:href="#icon-arrow-right"></use>
                    </svg>
                </i>
            `);
            $(element).find('.c-sub-nav__title--show a').attr('href', href);
        });
    },
    bindEvents() {
        this.mainNav.on('click', '.js-main-nav__item-title a', (evt) => {
            let $mainNavItem = $(evt.currentTarget).closest('.c-main-nav__item');
            if (($mainNavItem.find('.c-sub-nav').length > 0) && (Breakpoints.is('xs') || Breakpoints.is('sm'))) {
                evt.preventDefault();
            }
        });

        this.mainNav.on('click', '.js-main-nav__item-title', (evt) => {
            let self = $(evt.currentTarget);
            if (self.next('.c-sub-nav').length) {
                self.next('.c-sub-nav').addClass('c-sub-nav--active');
                let department = this.headerGender.find('.active').find('a').html();
                let title = department + '&nbsp;' + self.find('.c-main-nav__item-text').html();
                self.next('.c-sub-nav').find('.c-sub-nav__title--department').html(title);

            }
        });

        this.mainNav.on('click', '.back-level-2', () => {
            $('.c-sub-nav--active').removeClass('c-sub-nav--active');
        });

        this.mainNav.on('focusin', '.js-main-nav__item-title a', (evt) => {
            if (Breakpoints.is('xs') || Breakpoints.is('sm')) {
                // for now only desktop
                return;
            }
            $('.c-main-nav__item--focused').removeClass('c-main-nav__item--focused');
            const $mainNavItem = $(evt.currentTarget).closest('.c-main-nav__item');
            if (($mainNavItem.find('.c-sub-nav').length > 0)) {
                $mainNavItem.addClass('c-main-nav__item--focused');
            }
        });

        $('.page-main').on('focusin', () => {
            $('.c-main-nav__item--focused').removeClass('c-main-nav__item--focused');
        });

        this.mainNav.on('mouseover', '.js-main-nav__item-title a', (evt) => {
            if (Breakpoints.is('xs') || Breakpoints.is('sm')) {
                // for now only desktop
                return;
            }
            $('.c-main-nav__item--focused').removeClass('c-main-nav__item--focused');
        });

        $(document).on('keydown', function (event) {
            if (event.key === 'Escape') {
                $('.c-main-nav__item--focused').removeClass('c-main-nav__item--focused');
            }
        });
    }
};

// DOM ready
$(() => {
    if (mainNavigation.mainNav.length) {
        utils.logger.log('New Main navigation detected');
        mainNavigation.copyGender();
        mainNavigation.readGender();
        mainNavigation.addComponentsForMobile();
        mainNavigation.bindGenderSelection();
        mainNavigation.bindEvents();
    }
});

export default mainNavigation;
